import { KeyboardEvent, useCallback, forwardRef } from "react";
import { Input, InputProps } from "../Input";

export type InputCurrencyProps = {
  max?: number;
  value: number;
  onChange?: (value: number) => void;
} & InputProps;

const VALID_FIRST = /^[1-9]{1}$/;
const VALID_NEXT = /^[0-9]{1}$/;
const DELETE_KEY_CODE = 8;

export const InputCurrency = forwardRef<HTMLDivElement, InputCurrencyProps>(
  function InputCurrency(
    {
      max = Number.MAX_SAFE_INTEGER,
      onChange,
      value = 0,
      ...props
    },
    ref
  ) {
  const valueAbsTrunc = Math.trunc(Math.abs(value));

  if (
    value !== valueAbsTrunc ||
    !Number.isFinite(value) ||
    Number.isNaN(value)
  ) {
    throw new Error(`invalid value property`);
  }
  const handleKeyDown = useCallback(
    (e: KeyboardEvent<HTMLDivElement>): void => {
      const { key, keyCode } = e;
      if (
        (value === 0 && !VALID_FIRST.test(key)) ||
        (value !== 0 && !VALID_NEXT.test(key) && keyCode !== DELETE_KEY_CODE)
      ) {
        return;
      }

      const valueString = value.toString();
      let nextValue: number;
      if (keyCode !== DELETE_KEY_CODE) {
        const nextValueString: string =
          value === 0 ? key : `${valueString}${key}`;
        nextValue = Number.parseInt(nextValueString, 10);
      } else {
        const nextValueString = valueString.slice(0, -1);
        nextValue =
          nextValueString === "" ? 0 : Number.parseInt(nextValueString, 10);
      }
      if (nextValue > max) {
        return;
      }

      // console.log("nextValue", nextValue);
      !!onChange && onChange(nextValue);
    },
    [max, onChange, value]
  );

  const valueDisplay = (value / 100).toLocaleString("pt-br", {
    style: "currency",
    currency: "BRL",
  });

    return (
      <Input
        inputMode="tel"
        type="tel"
        onKeyDown={handleKeyDown}
        {...props}
        value={valueDisplay}
        ref={ref}
      />
    );
  }
);
